module.exports = __webpack_public_path__ + "static/media/bus.4cb010cf.svg";